// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"4faa798a","802":"adda18eb","921":"47b58cc6"}[chunkId] + ".chunk.js";
};